import { Button, Flex, FormControl, FormLabel, Grid, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text, Textarea } from "@chakra-ui/react"

interface Props {
    isOpen: boolean,
    onClose: any
}

const CancelEvent = ({ isOpen, onClose }: Props) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Cancelar agendamento</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Flex direction="column" w="100%">
                        <Text size="sm" mb="12px">Confirme o cancelamento do evento</Text>
                        <Grid
                            w="full"
                            templateColumns={{ sm: "1fr", md: "repeat(1, 1fr)" }}
                            gap="24px"
                            mb="24px"
                        >
                            <FormControl>
                                <FormLabel
                                    fontWeight="bold"
                                    fontSize="xs"
                                >
                                    Motivo do cancelamento
                                </FormLabel>
                                <Select placeholder="Selecione uma opção...">
                                    <option>Vida não poderá comparecer</option>
                                    <option>Médico não poderá comparecer</option>
                                    <option>Outro</option>
                                </Select>
                            </FormControl>
                            <FormControl>
                                <FormLabel
                                    fontWeight="bold"
                                    fontSize="xs"
                                >
                                    Detalhamento
                                </FormLabel>
                                <Textarea />
                            </FormControl>
                        </Grid>
                    </Flex>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={4}>
                        <Button variant="ghost" onClick={onClose}>Fechar</Button>
                        <Button colorScheme="red" onClick={onClose}>Cancelar</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default CancelEvent
